import { makeStyles } from '@material-ui/core/styles';
import { BellIcon } from '../../components/icons';

/*
 * Replaces the table's "No records to display" row. An empty inbox is the
 * normal state of this page, so it gets a full card rather than a bare line,
 * and says whether the emptiness is the inbox or the filters.
 */
const useStyles = makeStyles({
  panel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    minHeight: 280,
    padding: '48px 32px',
    borderRadius: 12,
    background: 'var(--bui-white)',
    boxShadow: 'var(--hone-portal-elevation-card)',
    textAlign: 'center',
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    background: 'var(--hone-portal-fill-inset)',
  },
  icon: {
    width: 18,
    height: 18,
    opacity: 0.45,
  },
  title: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: 'var(--bui-fg-primary)',
  },
  description: {
    margin: 0,
    maxWidth: 340,
    fontSize: 12.5,
    lineHeight: 1.5,
    color: 'var(--bui-fg-secondary)',
  },
});

export type NotificationsEmptyStateProps = {
  /** No filter is narrowing the query, so the inbox itself is empty. */
  isUnfiltered: boolean;
};

export function NotificationsEmptyState({
  isUnfiltered,
}: NotificationsEmptyStateProps) {
  const classes = useStyles();

  return (
    <section className={classes.panel}>
      <span className={classes.badge}>
        <BellIcon className={classes.icon} />
      </span>
      <p className={classes.title}>
        {isUnfiltered
          ? 'You are all caught up'
          : 'Nothing matches these filters'}
      </p>
      <p className={classes.description}>
        {isUnfiltered
          ? 'Announcements, incidents and other portal activity addressed to you will land here.'
          : 'Widen the view, the time window or the severity to see more.'}
      </p>
    </section>
  );
}
